import { render, staticRenderFns } from "./RegistrateContinueView.vue?vue&type=template&id=1fdc26c0&scoped=true"
import script from "./RegistrateContinueView.vue?vue&type=script&lang=ts"
export * from "./RegistrateContinueView.vue?vue&type=script&lang=ts"
import style0 from "./RegistrateContinueView.vue?vue&type=style&index=0&id=1fdc26c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc26c0",
  null
  
)

export default component.exports